module.exports = __webpack_public_path__ + "static/media/logoBlue.29b72877.svg";